<!-- Affichage des initiales quand l'image ne peut pas être chargée et qu'un nom est fourni -->
<div 
  *ngIf="imageError && showInitials && initials" 
  [class]="getImageClasses() + ' initials-container'"
  [ngStyle]="getInitialsStyle()"
  class="initials-display">
  {{ initials }}
</div>

<!-- Affichage de l'image par défaut quand pas d'initiales -->
<img 
  *ngIf="imageError && (!showInitials || !initials)"
  [src]="defaultSrc" 
  [alt]="alt"
  [class]="getImageClasses()"
  [style.width]="width"
  [style.height]="height"
/>

<!-- Affichage de l'image principale -->
<img 
  *ngIf="!imageError && src"
  [src]="getResolvedSrc()" 
  [alt]="alt"
  [class]="getImageClasses()"
  [style.width]="width"
  [style.height]="height"
  (error)="onImageError()"
  (load)="onImageLoad()"
/>

<!-- Affichage des initiales par défaut si pas d'image et qu'un nom est fourni -->
<div 
  *ngIf="!src && showInitials && initials" 
  [class]="getImageClasses() + ' initials-container'"
  [ngStyle]="getInitialsStyle()"
  class="initials-display">
  {{ initials }}
</div>

<!-- Affichage de l'image par défaut si pas d'image et pas d'initiales -->
<img 
  *ngIf="!src && (!showInitials || !initials)"
  [src]="defaultSrc" 
  [alt]="alt"
  [class]="getImageClasses()"
  [style.width]="width"
  [style.height]="height"
/>
